<template>
  <div
    class="air-monitor-device"
    v-loading="loading.value"
    :element-loading-text="$t(loading.text)"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="air-monitor-device-container" id="homeWarp">
      <div class="air-monitor-device-container-top">
        <div class="img-header" id="header0">
          <img
            src="../../../assets/image/head122.png"
            :style="{
              '--length': $t(superTitle).length + 5
            }"
            id="img0"
            alt=""
          />
          <div class="head-title">{{ $t(superTitle) }}</div>
        </div>
      </div>

      <div class="air-monitor-device-container-body">
        <!-- 核生化设备 -->
        <div class="device-warp own-warp">
          <div class="img-header own-img-header" id="header">
            <img
              src="../../../assets/image/head122.png"
              :style="{
                '--length': $t(title).length + 5
              }"
              id="img1"
              alt=""
            />
            <div class="head-title">{{ $t(title) }}</div>
          </div>

          <div class="device-area" v-if="ownerDevice.length">
            <div
              class="flag-point owner-flag-point"
              v-for="(pointItem, pointIndex) in floorFlagList"
              :id="pointItem"
              :key="pointItem"
              :style="{
                '--top': `${pointIndex * 180 + 30 * pointIndex - 20}px`
              }"
            ></div>

            <div class="device-box" v-if="nucleusDevice.length">
              <div
                v-for="item in nucleusDevice"
                class="device-box-item"
                :id="item.id"
                :key="item.id"
                :style="{
                  '--width': itemWidth,
                  '--per': percentNum
                }"
              >
                <deviceCard style="width: 100%; height: 100%" :item="item" />
              </div>
            </div>
            <div class="device-box" v-if="biologyDevice.length">
              <div
                v-for="item in biologyDevice"
                class="device-box-item"
                :id="item.id"
                :key="item.id"
                :style="{
                  '--width': itemWidth,
                  '--per': percentNum
                }"
              >
                <deviceCard style="width: 100%; height: 100%" :item="item" />
              </div>
            </div>
            <div class="device-box" v-if="chemistryDevice.length">
              <div
                v-for="item in chemistryDevice"
                class="device-box-item"
                :id="item.id"
                :key="item.id"
                :style="{
                  '--width': itemWidth,
                  '--per': percentNum
                }"
              >
                <deviceCard style="width: 100%; height: 100%" :item="item" />
              </div>
            </div>

            <div class="device-box" v-if="airDevice.length">
              <div
                v-for="item in airDevice"
                class="device-box-item"
                :id="item.id"
                :key="item.id"
                :style="{
                  '--width': itemWidth,
                  '--per': percentNum
                }"
              >
                <deviceCard style="width: 100%; height: 100%" :item="item" />
              </div>
            </div>
          </div>

          <div v-else>
            <el-empty :image-size="100" :description="$t('暂无设备')"></el-empty>
          </div>
        </div>

        <!--三防主机 滤毒 通风设备 -->
        <div class="device-warp excelus-warp">
          <div class="img-header" id="header1">
            <img
              src="../../../assets/image/head122.png"
              :style="{
                '--length': $t(exclusiveDeviceTitle).length + 5
              }"
              id="img2"
              alt=""
            />
            <div class="head-title">{{ $t(exclusiveDeviceTitle) }}</div>
          </div>
          <div class="device-box" v-if="exclusiveDeviceList.length">
            <div
              class="flag-point"
              v-for="(pointItem, pointIndex) in floorList"
              :id="pointItem"
              :key="pointItem"
              :style="{
                '--top': `${(pointIndex + 1) * 180 + 30 * pointIndex - 10}px`
              }"
            ></div>

            <div
              v-for="(item, index) in exclusiveDeviceList"
              class="device-box-item"
              :id="item.id"
              :key="index"
              :style="{
                '--width': itemWidth,
                '--per': percentNum
              }"
              @click="chooseSn(item.sn, item.state, item.deviceType, item.runMode)"
            >
              <div
                class="device-header"
                :class="
                  item.state
                    ? Object.keys(flickerDict).includes(item.state.toString())
                      ? flickerDict[item.state]
                      : ''
                    : ''
                "
                :id="`header${item.id}`"
                :style="{
                  '--color': item.bgColor
                }"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t(item.name)"
                  placement="top-start"
                >
                  <span>{{ $t(item.name) }}</span>
                </el-tooltip>
              </div>
              <div class="device-container">
                <div
                  class="air-icon-wrap"
                  :style="{
                    '--color': item.bgColor,
                    '--fontColor': item.fontColor
                  }"
                >
                  <i v-if="item.icon" :class="[item.icon, item.animate]"></i>
                  <div v-else class="air-icon-text" :class="item.animate">{{ $t('毒') }}</div>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <el-empty :image-size="100" :description="$t('暂无设备')"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jsPlumb } from 'jsplumb';
import { isArray } from '@/utils/is';
import { mapState } from 'vuex';
import { pointState } from '@/utils/dict';
import { getDeviceTypeImg } from '@/utils/deviceUtils';
import { externalDeviceListAllServer } from '@/api/air-monitor/device-center';
import { getOptions } from '@/utils/deviceUtils/state';

import deviceCard from './components/device-info-card.vue';

import ctt from '@/utils/const';

function treeDataRecu(count, result, arr, childNodes = []) {
  const leafNodes = [];
  let copyChildNodes;
  count++;
  if (isArray(arr)) {
    arr.forEach(e => {
      copyChildNodes = JSON.parse(JSON.stringify(childNodes));
      if (e.nodeType === 1) {
        copyChildNodes.push({
          name: e.name,
          id: e.id
        });
        treeDataRecu(count, result, e.children, JSON.parse(JSON.stringify(copyChildNodes)));
      } else {
        if (count === 1) {
          result.push({ childNodes: [{ name: e.name, id: e.id }], leafNodes: [] });
        } else {
          leafNodes.push(e);
        }
      }
    });
  }
  if (count !== 1 && leafNodes.length > 0) {
    result.push({ childNodes: copyChildNodes, leafNodes });
  }
}

function setDeviceImg(device) {
  device.forEach(item => {
    const imgInfo = getDeviceTypeImg(item.deviceType);
    item.imgSrc = imgInfo.picture;
  });
}

export default {
  components: {
    deviceCard
  },
  data() {
    return {
      exclusiveDeviceList: [],
      nucleusDevice: [],
      biologyDevice: [],
      chemistryDevice: [],
      airDevice: [],
      loading: {
        value: false,
        text: '加载中, 请耐心等待'
      },
      jsPlumbInstance: '', //jsPlumb实例
      floorFlagList: [],
      floorList: [],
      itemWidth: '4', // 设备盒子宽度,

      percentNum: '45%',
      // 闪烁报警
      flickerDict: {
        1: 'early-alarm',
        2: 'pulse-alarm',
        3: 'pulse-alarm'
      },
      superTitle: '上级平台',
      title: '核生化控制中心',
      exclusiveDeviceTitle: '三防控制主机'
    };
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap']),
    ...mapState('device', ['monitorMenuActive', 'deviceTypeInfo', 'monitorConfig']),
    ...mapState('app', ['menuCollapse', 'lang']),
    ...mapState('socket', ['deviceIdMap']),
    deviceList() {
      const count = 0;
      const result = [];
      const allDevice = [];
      treeDataRecu(count, result, this.$store.state.socket.deviceTree);
      result.forEach(item => {
        allDevice.push(...item.leafNodes);
      });

      setDeviceImg(allDevice);

      allDevice.forEach(item => {
        //          item.showName = `${item.name} (${this.getState(item.runstate, item.state).t})`;

        // let stateText = this.getState(item.runstate, item.state).t;
        // item.showName = `${item.name}(${this.$t(stateText)})`;
        item.showName = item.name;
      });
      return allDevice;
    },

    ownerDevice() {
      let nucleusType = [ctt.CR1224, ctt.CRA1221];
      let bioType = [ctt.CB1223, ctt.CB12231];
      let chemistryType = [ctt.HT100, ctt.HT200];
      let airType = [ctt.CT1226];
      let types = [...nucleusType, ...bioType, ...chemistryType, ...airType];

      let arr = this.deviceList.filter(item => {
        return types.includes(item.deviceType);
      });

      arr.forEach(item => {
        if (nucleusType.includes(item.deviceType)) {
          item.icon = 'iconfont icon-nuclide';
          item.showType = 'nucleus';
        } else if (bioType.includes(item.deviceType)) {
          item.icon = 'iconfont icon-bio';
          item.showType = 'bio';
        } else if (chemistryType.includes(item.deviceType)) {
          item.icon = 'iconfont icon-chemical-weapons';
          item.showType = 'chemistry';
        } else if (airType.includes(item.deviceType)) {
          item.icon = 'iconfont icon-leaf-2';
          item.showType = 'leaf';
        }
      });
      return arr;
    }
  },
  mounted() {
    this.loadOtherDeviceHandle();
  },
  watch: {
    lang: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$router.go(0);
          this.drawLines();
        }
      }
    }
  },

  methods: {
    getState(runstate, state) {
      return getOptions(runstate, state);
    },

    showLoading() {
      this.loading.value = true;
    },
    hideLoading() {
      if (!this.loading) return;
      setTimeout(() => {
        this.loading.value = false;
      }, 200);
    },
    async loadOtherDeviceHandle() {
      const animateDict = {
        respirator: ['icon-scale'],
        ventilate: ['icon-roate'],
        isolation: ['icon-scale']
      };

      const iconDict = {
        respirator: '',
        ventilate: 'iconfont icon-fan',
        isolation: 'iconfont icon-wind'
      };

      // const openText = this.$t('开启');
      // const closeText = this.$t('关闭');

      this.showLoading();
      try {
        const res = await externalDeviceListAllServer();

        if (res.code == 200) {
          this.exclusiveDeviceList = res.data;
          // this.exclusiveDeviceList = testArr;
          this.exclusiveDeviceList.forEach(item => {
            item.isOpen = Number(item.switchState);

            item.icon = iconDict[item.deviceTypeCode];
            item.animate = item.isOpen ? animateDict[item.deviceTypeCode] : '';
            if (item.isOpen) {
              item.fontColor = '#ffffff';
              item.bgColor = '#03b36e';
            } else {
              item.fontColor = '#c4c4c4';
              item.bgColor = '#949494';
            }

            // item.showName = this.$t(item.name);
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        Promise.all([this.setDeviceListLinesHandle(), this.setExclusiveDeviceListHandle()]).finally(
          () => {
            setTimeout(() => {
              this.drawLines();
            }, 200);

            this.hideLoading();
          }
        );
      }
    },

    groupBydeviceType(data) {
      const groups = {};

      data.forEach(item => {
        if (!groups[item.showType]) {
          groups[item.showType] = [];
        }
        groups[item.showType].push(item);
      });

      return groups;
    },
    splitGroups(groups) {
      const result = [];

      Object.keys(groups).forEach(showType => {
        const group = groups[showType];
        const chunks = [];

        for (let i = 0; i < group.length; i += 2) {
          chunks.push(group.slice(i, i + 2));
        }

        chunks.forEach(chunk => {
          result.push({
            showType: showType,
            items: chunk
          });
        });
      });

      return result;
    },

    mergeItemsByShowType(arr) {
      const merged = {};
      function processItems(items) {
        items.forEach(item => {
          if (item.showType && item.items) {
            if (!merged[item.showType]) {
              merged[item.showType] = [];
            }
            merged[item.showType].push(...item.items);
            item.items.forEach(subItem => {
              if (subItem.items) {
                processItems([subItem]);
              }
            });
          }
        });
      }

      processItems(arr);
      return merged;
    },

    setDeviceListLinesHandle() {
      this.floorFlagList = [];

      const groups = this.groupBydeviceType(this.ownerDevice);
      const rows = this.splitGroups(groups);
      const order = ['nucleus', 'bio', 'chemistry', 'leaf'];
      const sortedData = rows.sort((a, b) => order.indexOf(a.showType) - order.indexOf(b.showType));
      let allRows = sortedData.length;

      for (let index = 0; index < allRows; index++) {
        this.floorFlagList.push(`fl_${index}`);
      }

      sortedData.forEach((row, index) => {
        row.items.forEach(item => {
          item.flow = `fl_${index}`;
          item.line = {
            source: item.flow,
            target: item.id
          };
        });
      });

      let deviceDict = this.mergeItemsByShowType(sortedData);

      this.nucleusDevice = deviceDict['nucleus'];
      this.biologyDevice = deviceDict['bio'];

      this.chemistryDevice = deviceDict['chemistry'];
      this.airDevice = deviceDict['leaf'];

      this.floorFlagList = Array.from(new Set(this.floorFlagList));
      this.floorFlagList.unshift('header');

      this.floorFlagList.shift();
    },

    setExclusiveDeviceListHandle() {
      this.showLoading();
      this.exclusiveTargetIds = [];
      this.floorList = [];

      this.exclusiveDeviceList.forEach((item, index) => {
        let key = Math.trunc(index / 2);
        item.id = `exFl_${key}_${item.id}`;
        this.exclusiveTargetIds.push(item.id);

        if (key > 0) {
          this.floorList.push(`exFl_${key}`);
        }
      });

      this.floorList = Array.from(new Set(this.floorList));
      this.floorList.unshift('header1');

      this.exclusiveDeviceList.forEach((item, index) => {
        let key = Math.trunc(index / 2);
        item.line = {
          source: this.floorList[key],
          target: this.exclusiveTargetIds[index]
        };
      });

      this.floorList.shift();

      let lastFlagKey = this.floorList[this.floorList.length - 1];
      this.lastExclusiveFloorDevice = this.exclusiveDeviceList.filter(item => {
        return item.id.includes(lastFlagKey);
      });
    },

    drawLines() {
      let _this = this;

      _this.$nextTick().then(() => {
        jsPlumb.ready(() => {
          _this.jsPlumbInstance = jsPlumb.getInstance({
            Container: document.getElementById('homeWarp')
          });
          const baseLinkMethod = {
            isSource: true,
            isTarget: true,
            endpoint: 'Blank', // 端点类型
            paintStyle: { stroke: '#039ae2', strokeWidth: 2.5 } // 连线样式
          };

          const rightToLeftAnchor = {
            anchor: ['Right', 'Left']
          };

          const bottomToToptAnchor = {
            anchor: ['Bottom', 'Top']
          };

          const flowchartLinkType = {
            connector: ['Flowchart'] // 连线类型  flowChart 90°转角线
          };

          const straightLinkType = {
            connector: ['Straight'] // 连线类型
          };

          _this.jsPlumbInstance.connect(
            { source: `img0`, target: `img1` },
            Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
          );

          _this.jsPlumbInstance.connect(
            { source: `img1`, target: `img2` },
            Object.assign(baseLinkMethod, rightToLeftAnchor, straightLinkType)
          );

          //  122设备

          _this.jsPlumbInstance.connect(
            { source: `header`, target: `fl_0` },
            Object.assign(baseLinkMethod, bottomToToptAnchor, straightLinkType)
          );

          for (let i = 0; i < _this.floorFlagList.length; i++) {
            const current = _this.floorFlagList[i];
            const next = i < _this.floorFlagList.length - 1 ? _this.floorFlagList[i + 1] : null;
            if (next) {
              _this.jsPlumbInstance.connect(
                { source: current, target: next },
                Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
              );
            }
          }

          // 开始节点间的连线
          _this.nucleusDevice.forEach(item => {
            _this.jsPlumbInstance.connect(
              item.line,
              Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
            );
          });

          _this.biologyDevice.forEach(item => {
            _this.jsPlumbInstance.connect(
              item.line,
              Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
            );
          });

          _this.chemistryDevice.forEach(item => {
            _this.jsPlumbInstance.connect(
              item.line,
              Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
            );
          });

          _this.airDevice.forEach(item => {
            _this.jsPlumbInstance.connect(
              item.line,
              Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
            );
          });

          //   =====  其余设备 ====

          _this.jsPlumbInstance.connect(
            { source: 'header1', target: this.floorList[0] },
            Object.assign(baseLinkMethod, bottomToToptAnchor, straightLinkType)
          );

          for (let i = 0; i < _this.floorList.length; i++) {
            const current = _this.floorList[i];
            const next = i < _this.floorList.length - 1 ? _this.floorList[i + 1] : null;
            if (next) {
              _this.jsPlumbInstance.connect(
                { source: current, target: next },
                Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
              );
            }
          }

          _this.exclusiveDeviceList.forEach((item, _index) => {
            if (this.lastExclusiveFloorDevice.length === 1) {
              _this.jsPlumbInstance.connect(
                item.line,
                Object.assign(baseLinkMethod, bottomToToptAnchor, straightLinkType)
              );
            } else {
              _this.jsPlumbInstance.connect(
                item.line,
                Object.assign(baseLinkMethod, bottomToToptAnchor, flowchartLinkType)
              );
            }
          });
        });

        _this.jsPlumbInstance.repaintEverything(); // 重绘
      });
    },

    chooseSn(sn, state, deviceType, runMode) {
      if (
        runMode === ctt.MONITOR_DEVICE &&
        (state === undefined || state === ctt.POINT_STATE_UNCONNECT)
      ) {
        this.$message({ type: 'info', message: pointState[state] });
      } else {
        if (sn !== this.$route.params.sn) {
          this.$router.push({
            name: 'Realdata',
            params: { sn, deviceType }
          });
        }
      }
    }
  },

  beforeDestroy() {
    this.hideLoading();
  }
};
</script>

<style lang="scss">
@keyframes rotateFrames {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.icon-roate {
  animation: rotateFrames 10s linear infinite;
}

@keyframes iconScale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.icon-scale {
  animation: scale 2s ease-in-out infinite;
}

// 报警闪烁
.pulse-alarm {
  animation: pulse 1.5s infinite;
  background: rgba(255, 62, 68) !important;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
    box-shadow: 0 0 0 0 rgba(255, 62, 68, 0.7);
  }
  70% {
    opacity: 1;
    box-shadow: 0 0 0 20px rgba(255, 0, 0, 0);
  }
  100% {
    opacity: 0.6;
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

// 预警闪烁
.early-alarm {
  animation: earlyPulse 1.5s infinite;
  background: rgba(255, 86, 32) !important;
}

@keyframes earlyPulse {
  0% {
    opacity: 0.6;
    box-shadow: 0 0 0 0 rgba(255, 86, 32, 0.7);
  }
  70% {
    opacity: 1;
    box-shadow: 0 0 0 20px rgba(255, 0, 0, 0);
  }
  100% {
    opacity: 0.6;
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}
.img-header {
  margin-bottom: 40px;
  text-align: center;
  position: relative;

  img {
    min-width: 224px;
    width: calc(var(--length) * 20px);
    max-width: 480px;

    height: 76px;
  }
  .head-title {
    max-width: 450px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 25px;
    font-weight: bold;
  }
}

.text-ellipsis {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /* 限制行数 */
  -webkit-box-orient: vertical; /* 垂直排列布局中的盒子 */
}

.flag-point {
  height: 1px;
  width: 1px;
  background: #039ae2;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: var(--top);
}

.device-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  position: relative;
  padding: 0 25px;

  &-item {
    cursor: pointer;
    display: inline-block;
    border-radius: 10px;
    width: calc(var(--per) - 30px * calc(var(--width) - 1) / var(--width));
    // height: 10vw;
    height: 180px;
    box-sizing: border-box;
    .device-header {
      padding-left: 20px;
      font-size: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-radius: 10px 10px 0 0;
      height: 48px;
      line-height: 48px;
      color: #f5f5f5;
      background: var(--color);
      position: relative;
    }

    .device-container {
      height: calc(100% - 48px);
      padding: 10px;
      box-sizing: border-box;
      border: 2px solid #039ae2;
      background-color: #29475f;
      border-radius: 0 0 10px 10px;
      border-top: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width: 60%;
        height: 90%;
        object-fit: scale-down;
      }
      .device-text {
        width: 35%;
        text-align: right;
        span {
          @include state-textstyle;
        }
      }
      .air-icon-wrap {
        position: relative;
        // --color: #c4c4c4;
        --size: 60px;
        --base-size: 28px;
        width: var(--size);
        height: var(--size);
        border: 8px dashed var(--color);
        border-radius: 50%;
        background-color: var(--bg-color);
        opacity: 0.9;

        display: flex;
        justify-content: center;
        align-items: center;
        .iconfont {
          font-size: 40px !important;
          color: var(--fontColor);
        }
        .air-icon-text {
          font-size: 36px;
          font-weight: bold;
          color: var(--fontColor);

          &::after {
            color: var(--fontColor);

            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 5px;
            background: var(--color);
            transform: translateY(-50%) rotate(45deg);
          }
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.air-monitor-device {
  height: 100%;

  &-container {
    height: 100%;
    position: relative;
    overflow-y: auto;
    @include scrollar-style-thin;

    &::after {
      content: '';
      height: 20px;
    }

    &-top {
      width: 100% !important;
    }

    &-body {
      display: flex;

      .own-warp {
        .own-img-header {
          position: relative;
          left: -5%;
        }
        .device-area {
          position: relative;
          padding: 0 25px;
          .device-box {
            margin-bottom: 30px;
            justify-content: left !important;
          }
          .owner-flag-point {
            width: 1px !important;
            height: 1px !important;
            left: 45% !important;
          }
        }
      }

      .device-warp {
        width: calc(100% / 2);
        height: 100%;
      }
    }
  }
}
</style>
